export default __webpack_public_path__ + "static/media/BEL logo color white.7f7c1e6c.svg";